import React from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import Resize from './Resize';

const useStyles = makeStyles(() => ({
	screen: ({ color }) => ({
		backgroundColor: color,
	}),
}));

export default function Screen(props) {
	const { className, ratio } = props;

	const classes = useStyles({ color: '#00FF00' });

	return (
		<Resize
			className={className}
			ratio={ratio}
			component={(cprops) => (
				<div
					className={clsx(classes.screen, cprops.className)}
				/>
			)}
		/>
	);
}

Screen.defaultProps = {
	className: undefined,
};

Screen.propTypes = {
	className: propTypes.string,
	ratio: propTypes.string.isRequired,
};
